import { render, staticRenderFns } from "./SimpleLine.vue?vue&type=template&id=23c303e8&scoped=true&"
import script from "./SimpleLine.vue?vue&type=script&lang=js&"
export * from "./SimpleLine.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLine.vue?vue&type=style&index=0&id=23c303e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c303e8",
  null
  
)

export default component.exports